function currencyFormat(val: any, type?: string) {
  if (isNaN(val)) val = 0;
  if (typeof val !== 'number') val = Number(val);

  let result;

  if (type === 'export') {
    result = val
      .toLocaleString('en-EN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      .replace('.', ',');
    if (!result.includes(',')) {
      result += ',00';
    }
  } else {
    result = val.toLocaleString('en-EN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return result;
}

export default currencyFormat;
